import { render, staticRenderFns } from "./Protections.vue?vue&type=template&id=afb94f8e&scoped=true&"
import script from "./Protections.vue?vue&type=script&lang=js&"
export * from "./Protections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb94f8e",
  null
  
)

export default component.exports